<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">招标文件管理</h2>
            </div>
        </div>
        
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <label class="search-label">标段名称:</label>
                <el-input v-model="searchForm.sectionName" placeholder="请输入标段名称" class="search-input" clearable />
                <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
                    搜索
                </el-button>
            </div>
            <div style="display: flex; align-items: center;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>
        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column type="index" label="NO." width="60" align="center" :index="indexMethod" />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="bidSectionCode" label="标段编号" show-overflow-tooltip />
                <el-table-column prop="isBlindReview" label="评审方式" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isBlindReview === 1 ? 'warning' : 'success'" size="small">
                            {{ scope.row.isBlindReview === 1 ? '暗标' : '明标' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" align="center" width="180">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" size="small">
                            {{ getStatusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" align="center" width="350">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 投标人列表弹窗 -->
        <el-dialog title="投标人列表" :visible.sync="bidderDialogVisible" width="70%" :close-on-click-modal="false"
            :append-to-body="true">
            <!-- 搜索区域 -->
            <div class="dialog-search-section">
                <el-input v-model="bidderSearchForm.bidderName" placeholder="请输入投标人名称" class="search-input" clearable
                    style="width: 300px;" />
                <el-button type="primary" icon="el-icon-search" @click="handleBidderSearch" style="margin-left: 10px;">
                    搜索
                </el-button>
            </div>

            <!-- 投标人表格 -->
            <el-table :data="bidderTableData" v-loading="bidderLoading" border style="width: 100%; margin-top: 20px;">
                <el-table-column type="index" label="NO." width="60" align="center" :index="bidderIndexMethod" />
                <el-table-column prop="bidderName" label="投标人名称" show-overflow-tooltip />
                <el-table-column prop="contact" label="联系人" show-overflow-tooltip />
                <el-table-column prop="phone" label="联系电话" show-overflow-tooltip />
                <el-table-column prop="uploadTime" label="上传时间" show-overflow-tooltip width="180" />
                <el-table-column label="操作" align="center" width="260">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="getBidderFile(scope.row.bidderCode, false)">明标正文</el-button>
                        <el-button type="text" size="small" @click="getBidderFile(scope.row.bidderCode, true)">暗标正文</el-button>
                        <el-button type="text" size="small" @click="handlePrintAttachment(scope.row)">附件</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 弹窗分页 -->
            <div class="dialog-pagination-section">
                <el-pagination @size-change="handleBidderSizeChange" @current-change="handleBidderCurrentChange"
                    :current-page="bidderPagination.currentPage" :page-sizes="[10, 20, 50, 100]"
                    :page-size="bidderPagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="bidderPagination.total" />
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="bidderDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 附件查看弹窗 -->
        <el-dialog title="附件" :visible.sync="attachmentViewDialogVisible" width="600px" :append-to-body="true">
            <el-table :data="attachmentViewList" border style="width: 100%"
                :header-cell-style="{ backgroundColor: '#f5f7fa', fontWeight: 'bold' }">
                <el-table-column prop="fileName" label="文件名称(点击下载)" min-width="260">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.fileName" type="primary"
                            @click="handleFileDownload(scope.row)" class="file-link">
                            {{ scope.row.fileName }}
                        </el-link>
                        <span v-else class="no-data">暂无数据</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fileExtension" label="文件类型" width="120" align="center"></el-table-column>
                <el-table-column prop="fileSize" label="文件大小" width="120" align="center"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleFileDownload(scope.row)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="attachmentViewDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { bidDocumentList, bidderList } from "@/api/bidDocument/api";
import { getBlindFile, getBidderFile as getBidderFileApi, getBidderAttachment } from '@/api/evaluation/api'

export default {
    name: 'PoliticsProjectManage',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            searchForm: {
                sectionName: ''
            },
            loading: false,
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 1
            },
            // 投标人弹窗相关数据
            bidderDialogVisible: false,
            bidderLoading: false,
            bidderTableData: [],
            currentBidSectionCode: '', // 当前查看的标段编号
            bidderSearchForm: {
                bidderName: ''
            },
            bidderPagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            pdfUrl: '',
            isBlindReview: false,
            attachmentViewDialogVisible: false,
            attachmentViewList: []
        }
    },
    mounted() {
        this.getProjectInfo();
        this.bidDocumentList()
    },
    methods: {
        //  标段标段列表
        bidDocumentList() {
            this.loading = true;
            bidDocumentList({
                projectCode: this.projectCode,
                pageNum: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,
                bidSectionName: this.searchForm.sectionName,
                stage: 0,
            }).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data.records || [];
                    this.pagination.total = res.data.total || 0;
                }
            }).catch(err => {
                this.$message.error('获取标段列表失败');
                console.error(err);
            }).finally(() => {
                this.loading = false;
            });
        },
        handleBack() {
            this.$router.go(-1)
        },

        //  获取标题
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode);
        },

        handleSearch() {
            this.pagination.currentPage = 1;
            this.bidDocumentList();
        },
        handleViewDetails(row) {
            this.currentBidSectionCode = row.bidSectionCode;
            this.bidderSearchForm.bidderName = '';
            this.bidderPagination.currentPage = 1;
            this.bidderPagination.pageSize = 10;
            this.bidderDialogVisible = true;
            this.getBidderList();
        },
        // 查看投标人列表
        getBidderList() {
            this.bidderLoading = true;
            bidderList({
                bidSectionCode: this.currentBidSectionCode,
                bidderName: this.bidderSearchForm.bidderName,
                pageNum: this.bidderPagination.currentPage,
                pageSize: this.bidderPagination.pageSize
            }).then(res => {
                if (res.code === 200) {
                    this.bidderTableData = res.data.records || [];
                    this.bidderPagination.total = res.data.total || 0;
                }
            }).catch(err => {
                this.$message.error('获取投标人列表失败');
                console.error(err);
            }).finally(() => {
                this.bidderLoading = false;
            });
        },
        // 投标人搜索
        handleBidderSearch() {
            this.bidderPagination.currentPage = 1;
            this.getBidderList();
        },
        // 投标人序号计算
        bidderIndexMethod(index) {
            return (this.bidderPagination.currentPage - 1) * this.bidderPagination.pageSize + index + 1;
        },
        // 投标人分页大小改变
        handleBidderSizeChange(val) {
            this.bidderPagination.pageSize = val;
            this.bidderPagination.currentPage = 1;
            this.getBidderList();
        },
        // 投标人当前页改变
        handleBidderCurrentChange(val) {
            this.bidderPagination.currentPage = val;
            this.getBidderList();
        },
        // 获取投标人文件 (支持明标和暗标)
        getBidderFile(userIdParam, isBlind) {
            const uid = userIdParam;
            this.isBlindReview = isBlind;
            const requestApi = this.isBlindReview ? getBlindFile : getBidderFileApi;
            requestApi({
                userId: uid,
                sectionCode: this.currentBidSectionCode,
            }).then(res => {
                if (res.code === 200) {
                    if (res.data) {
                        this.pdfUrl = res.data;
                        window.open(res.data, '_blank');
                    } else {
                        this.$message.warning( this.isBlindReview? '暗标文件未上传':'明标文件未上传');
                    }
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(err => {
                this.$message.error('获取文件路径失败');
                console.error(err);
            });
        },
        // 获取并展示投标人附件列表
        async handlePrintAttachment(row) {
            const uid = row.bidderCode;
            const sectionCode = Cookies.get('bidSectionCode') || this.currentBidSectionCode;
            try {
                const res = await getBidderAttachment({
                    sectionCode: sectionCode,
                    userId: uid
                });
                if (res.code === 200) {
                    this.attachmentViewList = Array.isArray(res.data) ? res.data : [];
                    this.attachmentViewDialogVisible = true;
                } else {
                    this.$message.error(res.msg || '获取附件列表失败');
                }
            } catch (err) {
                this.$message.error('获取附件列表异常');
                console.error(err);
            }
        },
        // 处理附件文件下载
        handleFileDownload(file) {
            console.log('下载附件文件:', file);
            if (!file || !file.fileUrl) {
                this.$message.warning('文件链接不存在');
                return;
            }
            const link = document.createElement('a');
            link.href = file.fileUrl;
            link.download = file.fileName;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$message.success(`开始下载: ${file.fileName}`);
        },
        // 序号计算方法
        indexMethod(index) {
            return (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1;
        },
        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                0: '未设置开标时间',
                1: '可查看',
                2: '够3家（未到开标时间）',
                3: '不足3家（未到开标时间）',
                4: '不足3家（已到开标时间）'
            };
            return statusMap[status] || '未知状态';
        },
        // 获取状态标签类型
        getStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'success',
                2: 'primary',
                3: 'warning',
                4: 'danger'
            };
            return typeMap[status] || 'info';
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.pagination.currentPage = 1;
            this.bidDocumentList();
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.bidDocumentList();
        },
    }

}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 页面特定样式
// ============================================

// 页面头部
.page-header {
    margin-bottom: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }
}

// 弹窗内搜索区域
.dialog-search-section {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    padding: 12px;
    background: @gray-50;
    border-radius: 4px;
}

// 弹窗内分页
.dialog-pagination-section {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid @gray-200;
}
</style>